<div class="container-fluid py-4">
    <div class="row">

        <app-menu-item 
            *ngFor="let menu of menuData"
            [menuItem]="menu">
        </app-menu-item>

    </div>
</div>